module.exports = __webpack_public_path__ + "static/media/header-bg.31990db4.png";